import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';

class FootIntro extends React.PureComponent {
    render() {
        return (
            <div className={styles.footIntroContainer}>
                <img src="//p3.ifengimg.com/a/2017/1013/logo_5351d7af.jpg" title="大美中国" alt="大美中国" />
                <div className={styles.txt}>
                    <h4>栏目介绍</h4>
                    <p>
                        栏目介绍：凤凰网旅游境内目的地深度行走类栏目，探寻灿烂的人文印记，访遍中国大地最壮丽辽阔的山水画卷，感受极致旅行体验。
                    </p>
                    <p className={styles.pTs}>出品：凤凰网旅游；主编：许玥</p>
                </div>
            </div>
        );
    }
}

export default errorBoundary(FootIntro);
